export default __webpack_public_path__ + "static/media/slack.255b5f36.svg";